// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import "element-ui/lib/theme-chalk/index.css";
// import Vue from "vue";
import App from './App'
import routers from './router'
import 'babel-polyfill'
import md5 from 'js-md5'
import { cookieStorage } from './common/storage'
import VideoPlayer from 'vue-video-player'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// vuex
import Store from './store/index'
// 导入请求框架
import api from './api'
import {GetDictAllList} from './api/user'

import axios from 'axios'
// 导入element组件
import ElementUI from 'element-ui'

// 导入jquery

import $ from 'jquery'

// 使用copy功能
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

// 使用element-ui
Vue.use(ElementUI)

Vue.use(VideoPlayer)
Vue.use(preview)

Vue.use(Vuex)

Vue.use(VueRouter)

Vue.prototype.$md5 = md5

Vue.use(Viewer)
Viewer.setDefaults({
  inline: false,
  button: true, // 右上角按钮
  navbar: false, // 底部缩略图
  title: false, // 当前图片标题
  toolbar: true, // 底部工具栏
  tooltip: true, // 显示缩放百分比
  movable: true, // 是否可以移动
  zoomable: true, // 是否可以缩放
  rotatable: true, // 是否可旋转
  scalable: true, // 是否可翻转
  transition: true, // 使用 CSS3 过度
  fullscreen: true, // 播放时是否全屏
  keyboard: true // 是否支持键盘
})
Vue.use(VueClipboard)
// 使用api
Vue.use(api)

Vue.config.productionTip = false

// import Router from "vue-router";
// import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload)

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

let store = new Vuex.Store(Store)
let router = new VueRouter(routers)

Vue.prototype.router = router
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
console.log('ssss', window.serverConfig)
Vue.prototype.serverConfig = window.serverConfig
// 路由开始之前的操作
// 获取元素

router.beforeEach(async (to, from, next) => {
  var linkElement = document.getElementById('linkIcon')
  if (window.serverConfig.agentCode == '') {
    document.title = '十进制网络'
    linkElement.href = 'static/img/sjz.ico'
  }
  if (window.serverConfig.agentCode == 'dtgt') {
    document.title = '大唐国投云数据'
    linkElement.href = 'static/img/dtgt.ico'
  }
  if (window.serverConfig.agentCode == 'bdth') {
    document.title = '北斗天绘'
    linkElement.href = 'static/img/bdth.png'
  }

  // document.getElementById('linkIcon').hasAttribute('href')
  let toName = to.name
  let is_login = (JSON.stringify(cookieStorage.get('domainisLogin')) != '{}')
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断该路由是否需要登录权限
    if (is_login) {
      next()
    } else {
      next({
        path: '/HomeSearch'
      })
    }
  } else {
    // console.log(to, from)
    // console.log(Vue.prototype.agentCode)
    if (window.serverConfig.agentCode) {
      // 无实际用途 暂时注释

      // await GetDictAllList({ DictID: 111199689838401 })
      // .then(({ code, data, msg }) => {
      //   if (code == 200) {
      //     let datalist = eval(data)

      //     datalist.forEach(res => {
      //       let n = eval(res.Remark)

      //       // this.dataremarklist.push(n)
      //     })
      //     //  console.log(this.dataremarklist)
      //   } else {
      //     //   this.searchSuccess = false
      //     this.$message({
      //       message: msg,
      //       type: 'warning'
      //     })
      //   }
      // })
      if (to.path === '/' || to.path === '/index') {
        next({
          path: '/HomeSearch'
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

// function getServerConfig () {
//   return new Promise((resolve, reject) => {
//     axios.get('./static/serverConfig.json').then(result => {
//       Vue.prototype.agentCode = result.data.agentCode
//       Vue.prototype.baseUrl = result.data.baseUrl
//       resolve()
//     })
//   })
// }
/* eslint-disable no-new */
function getTitle () {
  // return new Promise((resolve, reject) => {
  //   axios({
  //     url: 'https://oa.zjbdth.cn/bdthwebapi/Entity/GetDictConstValue',
  //     method: 'get',
  //     params: {
  //       Key: 'webtitle'
  //     }
  //   }).then(result => {
  //     Vue.prototype.title = result.data.data
  //     resolve()
  //   })
  // })
  Vue.prototype.title = '十进制网络'
}

// 在main.js中
// 提交以后禁用按钮一段时间，防止重复提交
Vue.directive('noMoreClick', {
  inserted (el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 500)
    })
  }
})

async function main () {
  // await getServerConfig()
  await getTitle()
  new Vue({
    el: '#app',
    router,
    store,
    components: {
      App
    },
    template: '<App/>'
  })
}
main()



// WEBPACK FOOTER //
// ./src/main.js